import { useState, useCallback, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import { TeamProvider, useTeam } from '../contexts/TeamContext'
import { useCurrentTeam } from '../contexts/CurrentTeamContext'
import { NodesProvider } from '../contexts/NodesContext'
import { ProjectsProvider } from '../contexts/ProjectsContext'
import { ServicesProvider } from '../contexts/ServicesContext'
import { DeploymentsProvider } from '../contexts/DeploymentsContext'
import { DomainsProvider } from '../contexts/DomainsContext'
import { AddressesProvider } from '../contexts/AddressesContext'
import { DockerNetworksProvider } from '../contexts/DockerNetworksContext'
import { RegistriesProvider } from '../contexts/RegistriesContext'
import { RegistryCredentialsProvider } from '../contexts/RegistryCredentialsContext'
import { IngressesProvider } from '../contexts/IngressesContext'
import { NodeTasksProvider } from '../contexts/NodeTasksContext'
import { PackageImportsProvider } from '../contexts/PackageImportsContext'
import { HetznerProjectsProvider } from '../contexts/HetznerProjectsContext'
import { HetznerServersProvider } from '../contexts/HetznerServersContext'
import TopBar from '../shared/components/navigation/TopBar'
import Sidebar from '../shared/components/navigation/Sidebar'
import LoadingState from '../shared/components/LoadingState'
import ErrorState from '../shared/components/ErrorState'

function TeamContent() {
  const { loading, error } = useTeam()

  if (loading) return <LoadingState />
  if (error) return <ErrorState messageId="teams.error" />

  return <Outlet />
}

function TeamSync() {
  const { team } = useTeam()
  const { setTeam, clearTeam } = useCurrentTeam()

  useEffect(() => {
    if (team?.id) {
      setTeam(team.id)
    }
    return () => clearTeam()
  }, [team?.id, setTeam, clearTeam])

  return null
}

function TeamLayout() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const handleMenuToggle = useCallback(() => setMobileOpen((prev) => !prev), [])
  const handleDrawerClose = useCallback(() => setMobileOpen(false), [])

  return (
    <TeamProvider>
      <TeamSync />
      <NodesProvider>
        <ProjectsProvider>
          <ServicesProvider>
            <PackageImportsProvider>
            <DeploymentsProvider>
              <DomainsProvider>
              <AddressesProvider>
              <DockerNetworksProvider>
                <RegistriesProvider>
                <RegistryCredentialsProvider>
                  <IngressesProvider>
                  <NodeTasksProvider>
                  <HetznerProjectsProvider>
                  <HetznerServersProvider>
                    <Box sx={{ display: 'flex', bgcolor: 'navigation.main', height: '100vh', overflow: 'hidden' }}>
                      <TopBar showTasksIndicator showPendingChanges onMenuToggle={handleMenuToggle} />
                      <Sidebar open={mobileOpen} onClose={handleDrawerClose} />
                      <Box
                        component="main"
                        sx={{
                          flexGrow: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          p: { xs: 0, md: 1 },
                          pt: 0,
                          minHeight: 0,
                        }}
                      >
                        <Toolbar />
                        <Box
                          data-scroll-container
                          sx={{
                            flexGrow: 1,
                            bgcolor: 'background.default',
                            borderRadius: { xs: 0, md: 3 },
                            overflow: 'auto',
                            minHeight: 0,
                          }}
                        >
                          <TeamContent />
                        </Box>
                      </Box>
                    </Box>
                  </HetznerServersProvider>
                  </HetznerProjectsProvider>
                  </NodeTasksProvider>
                  </IngressesProvider>
                </RegistryCredentialsProvider>
                </RegistriesProvider>
              </DockerNetworksProvider>
              </AddressesProvider>
              </DomainsProvider>
            </DeploymentsProvider>
            </PackageImportsProvider>
          </ServicesProvider>
        </ProjectsProvider>
      </NodesProvider>
    </TeamProvider>
  )
}

export default TeamLayout
